export default "__VITE_ASSET__d9068544__"